import { DiameterIcon } from './DiameterIcon';

/**
 * author: Michael Richins
 * id 64CBC510-072A-477D-99DD-F8114E7E312E
 * name diameter
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/diameter.svg
 * tags
 * - Math 
 */
export const SphereDiameterIcon = DiameterIcon;
export default SphereDiameterIcon